const PaymentPlatforms = {
  stripe: 'stripe',
  spreedly: 'spreedly',
  payfabric: 'payfabric',
  rectangle: 'rectangle',
  globalpay: 'globalpay',
};

export default PaymentPlatforms;
